<template>
    <div v-if="statusOptions && isVisible">
        <div class="row mt-0">
            <div class="col-3">
                <app-input-select :options="formatosOptions" :disabled="false" v-model="dataOptions.formato"
                    label="Formato" id="formato" :notDefault="true" @input="handlePropertie" :userAdmin="userAdmin" />
            </div>
            <div class="col-3">
                <app-input-text label="Tipo de entrega" :icon="true" :contentType="1" id="tipo_de_entrega"
                    :value="dataOptions.tipo_de_entrega" @input="handlePropertie" @change="inputValueChange" />
            </div>
            <div class="col-2">
                <app-input-text label="Qtda total" :icon="true" :contentType="12" id="qtda"
                    :value="dataOptions.qtda.toString()" @input="handlePropertie" @change="inputValueChange"
                    :userAdmin="userAdmin" />
            </div>
            <div class="col-2">
                <app-input-text label="Qtda templati." :icon="true" :contentType="12" id="qtda_templatizada"
                    :value="dataOptions.qtda_templatizada.toString()" @input="handlePropertie"
                    @change="inputValueChange" :userAdmin="userAdmin" />
            </div>
            <div class="col-2">
                <app-input-select :options="versionamentosOptions" :disabled="false" v-model="dataOptions.versionamento"
                    label="Versionamento" :notDefault="true" id="versionamento" @input="handlePropertie"
                    :userAdmin="userAdmin" />
            </div>
            <div class="col-3">
                <app-input-select :options="statusOptions" :disabled="false" v-model="dataOptions.status" label="Status"
                    id="status" :notDefault="true" @input="handlePropertie" :userAdmin="userAdmin" />
            </div>
            <div class="col-3">
                <app-input-date :value="dataOptions.data_entrada_briefing" id="data_entrada_briefing"
                    label="Data entrada briefing" @input="handlePropertie" :userAdmin="userAdmin" />
            </div>
            <div class="col-3">
                <app-input-date :value="dataOptions.data_entrada" id="data_entrada" label="Data entrada"
                    @input="handlePropertie" :userAdmin="userAdmin" />
            </div>
            <div class="col-3">
                <app-input-date :value="dataOptions.data_saida" id="data_saida" label="Data Saída"
                    @input="handlePropertie" :userAdmin="userAdmin" />
            </div>
            <div class="col-6 mb-3" v-if="userAdmin === 1">
                <button class="btn btn-primary bg-gray" @click="handleDuplicate(id)">
                    Duplicar
                </button>
                <button class="btn btn-danger mx-3" @click="handleRemove(id)">
                    Remover
                </button>
            </div>
        </div>
    </div>
</template>
<script>

import { status, versionamentos, formatos } from '../../../data/data-static.js'
import { mapActions } from "vuex";
import AppInputSelect from "@/components/AppInputSelect/AppInputSelect.vue";
import AppInputText from "@/components/AppInputText/AppInputTextFormats.vue";
import AppInputDate from "@/components/AppInputDate/AppInputDate.vue";
export default {
    props: {
        task_id: {
            type: [String, Number],
            required: true
        },
        id: {
            type: [String, Number],
            required: false
        },
        formato: {
            type: [String, Number],
            required: false,
            default: null
        },
        tipo_de_entrega: {
            type: [String, Number],
            required: false,
            default: null
        },
        qtda: {
            type: [String, Number],
            required: false,
            default: 0
        },
        qtda_templatizada: {
            type: [String, Number],
            required: false,
            default: 0
        },
        versionamento: {
            type: [String, Number],
            required: false,
            default: null
        },
        data_entrada_briefing: {
            type: [String, Number],
            required: false,
            default: null
        },
        data_entrada: {
            type: [String, Number],
            required: false,
            default: null
        },
        data_saida: {
            type: [String, Number],
            required: false,
            default: null
        },
        status: {
            type: [String, Number],
            required: false,
            default: null
        },
        userAdmin: { type: [Number, String], required: false }
    },
    components: {
        AppInputSelect,
        AppInputText,
        AppInputDate
    },
    computed: {
        statusOptions() {
            return status
        },
        versionamentosOptions() {
            return versionamentos
        },
        formatosOptions() {
            return formatos
        }
    },
    data() {
        return {
            isVisible: true,
            dataOptions: {
                formato: this.formato,
                tipo_de_entrega: this.tipo_de_entrega,
                qtda: this.qtda,
                qtda_templatizada: this.qtda_templatizada,
                versionamento: this.versionamento,
                data_entrada_briefing: this.data_entrada_briefing,
                data_entrada: this.data_entrada,
                data_saida: this.data_saida,
                status: this.status
            }
        }
    },
    methods: {
        ...mapActions([
            "showMessage"
        ]),
        inputValueChange() {
            console.log('inputValueChange')
        },
        async handleDuplicate(id) {
            const data = {
                id: id
            };
            try {
                const { url, options } = this.$getAPIHeadersFetch("POST", `task-properties-all-copy`, data);
                const response = await fetch(url, options);
                const result = await response.json();
                if (result.status === 200 || result.status === 201) {
                    console.log('result.data', result.data)
                    this.$emit("pushData", result.data);
                    this.showMessage({
                        title: 'Duplicado!',
                        css: "bg-success"
                    });
                }
                else {
                    this.showMessage({
                        title: "Por favor, revise os dados fornecidos.",
                        text: result.errors,
                        css: "bg-danger"
                    });
                }
            } catch (error) {
                this.showMessage({
                    title: "Desculpe um erro aconteceu, por favor, tente novamente.",
                    css: "bg-danger"
                });
                console.log(error);

            }
        },
        async handlePropertie(v, n) {
            const data = {
                type: n,
                value: v
            };
            this.dataOptions[n] = v;
            try {
                const { url, options } = this.$getAPIHeadersFetch("POST", `task-properties-all-update/${this.task_id}/${this.id}`, data);
                const response = await fetch(url, options);
                const result = await response.json();
                if (result.status === 200 || result.status === 201) {
                    if (n === "qtda" || n === "qtda_templatizada") {
                        this.$emit('updateData', { ...data, id: this.id });
                    }
                } else {

                    this.showMessage({
                        title: "Por favor, revise os dados fornecidos.",
                        text: result.errors,
                        css: "bg-danger"
                    });

                }
            } catch (error) {
                this.showMessage({
                    title: "Desculpe um erro aconteceu, por favor, tente novamente.",
                    css: "bg-danger"
                });

            }
        },
        async handleRemove(id) {
            try {
                const { url, options } = this.$getAPIHeadersFetch("POST", `task-properties-all-remove/${id}`);
                const response = await fetch(url, options);
                const result = await response.json();
                if (result.status === 200 || result.status === 201) {
                    //this.isVisible = !this.isVisible
                    this.$emit("sliceData", id)
                } else {

                    this.showMessage({
                        title: "Desculpe um erro aconteceu, por favor, tente novamente.",
                        text: result.errors,
                        css: "bg-danger"
                    });

                }
            } catch (error) {
                this.showMessage({
                    title: "Desculpe um erro aconteceu, por favor, tente novamente.",
                    css: "bg-danger"
                });
                console.log(error);

            }
        }
    }
}
</script>
<style scoped>
.btn {
    padding-left: 15px;
    padding-right: 15px;
    max-height: 42px;
}

.pre-buttons {
    width: 100%;
    /*display: flex;
    justify-content: space-between;
    height: 42px;*/
}
</style>